import {InlineError, Input} from "avo-ui";
import TabToggle from "components/commons/tab-toogle";
import Select from "components/commons/select";

export const PopularBrand = ({ dataBrand, onSearchBrand, optionsBrand, onChangeBrand, errorForm }) => {
    return (
        <TabToggle
            title={'Popular Brand'}
            content={
                <div className={'flex flex-col w-1/2 space-y-5'}>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Title Highlight Brand</div>
                        <Input
                            className={'flex-1'}
                            name={'section_title'}
                            placeholder={'Masukkan title highlight brand'}
                            value={dataBrand?.section_title}
                            onChange={(item) => onChangeBrand({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.brand_data?.section_title} />
                    </div>
                    <div className={'flex flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Pilih Brand</div>
                        <Select
                            name={'brand_ids'}
                            className={'flex-1'}
                            optionsClassName={'max-h-40'}
                            placeholder={'Pilih brand'}
                            options={optionsBrand}
                            value={dataBrand?.brand_ids}
                            searchable
                            isMultiple
                            onChange={(item) => onChangeBrand({[item?.name]: item?.value})}
                            onSearch={(value) => onSearchBrand(value)}
                        />
                        <InlineError className='mt-2' message={errorForm?.brand_data?.brand_ids} />
                    </div>
                </div>
            }
        />
    )
}
